module.exports = __webpack_public_path__ + "c8bd56b855d80c4eb71b6345fd4ae60d.png";